import { render, staticRenderFns } from "./BaseArticle.vue?vue&type=template&id=5d477b53&scoped=true&"
import script from "./BaseArticle.vue?vue&type=script&lang=js&"
export * from "./BaseArticle.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticle.vue?vue&type=style&index=0&id=5d477b53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d477b53",
  null
  
)

export default component.exports